import React from "react";
import { Box, Typography } from "@mui/material";
import { Textfield } from "../../../../components";
import { displayError } from "../../../../helpers";

export default function ({ state, handleChange, validationErrors }) {
    return <Box sx={{ padding: '20px 50px', border: '1px solid #eee', display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <Typography variant="small">Make your cheque payable to 'The Citizens Foundation' and enter your cheque number below. After you complete the form, a TCF Representative will get in touch to schedule a pickup at your convenience.</Typography>
        <Textfield
            id="chequeNumber"
            name='chequeNumber'
            value={state.chequeNumber}
            onChange={handleChange}
            label="Please enter your cheque number *"
            error={displayError(validationErrors.paymentMethodDetails?.cheque)}
            helperText={validationErrors.paymentMethodDetails?.cheque}
            fullWidth
        />
    </Box>
}